import React from "react";
import { CardHeader, Checkbox, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import { LoadingButton } from "@mui/lab";

const CateringTypes = (props) => {
  const {
    shopWebsiteConfig,
    handleChange,
    handleSave,
    handleRestore,
    loadingButton,
  } = props?.shopWebsiteCustomization;
  const data = shopWebsiteConfig?.Catering;
  return (
    <Card className="bg-white shadow-sm">
      <CardHeader
        title={
          <div className="text-[#24211F] text-base font-bold">
            Catering that shop offers
          </div>
        }
      ></CardHeader>
      <div style={{ border: "1px solid #ccc", height:'387px'}} >
        <CardContent>
          <Grid container gap={1}>
            <Grid item xs={12}>
              <div className="flex justify-between">
                <div className="flex justify-start w-full">
                  <img
                    src={"../../assets/images/pickUp.svg"}
                    alt="pickUp"
                    width={"34px"}
                    height={"26px"}
                  />
                  <p className="self-center text=[#24211F] text-base pl-1">
                    Pick Up
                  </p>
                </div>
                <div>
                  <Checkbox
                    id={"bitPickUp"}
                    name={"bitPickUp"}
                    disabled={true}
                    style={{opacity:'0.5'}}
                    checked={data?.bitPickUp ===1 ? true :false}
                    sx={{
                      "&.Mui-checked": {
                        color: "#C12637",
                      },
                    }}
                    onChange={(e) =>
                      handleChange("Catering", "bitPickUp", e.target.checked ? 1 : 0)
                    }
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex justify-between">
                <div className="flex justify-start w-full">
                  <img
                    src={"../../assets/images/fullService.svg"}
                    alt="bitFullService"
                    width={"34px"}
                    height={"26px"}
                  />
                  <p className="self-center text=[#24211F] text-base pl-1">
                    Full Service
                  </p>
                </div>
                <div>
                  <Checkbox
                    id={"bitFullService"}
                    name={"bitFullService"}
                    checked={data?.bitFullService  ===1 ? true :false}
                    sx={{
                      "&.Mui-checked": {
                        color: "#C12637",
                      },
                    }}
                    onChange={(e) =>
                      handleChange(
                        "Catering",
                        "bitFullService",
                        e.target.checked ? 1 : 0
                      )
                    }
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex justify-between">
                <div className="flex justify-start w-full">
                  <img
                    src={"../../assets/images/delivery.svg"}
                    alt="pickUp"
                    width={"34px"}
                    height={"26px"}
                  />
                  <p className="self-center text=[#24211F] text-base pl-1">
                    Delivery
                  </p>
                </div>
                <div>
                  <Checkbox
                    id={"bitDelivery"}
                    name={"bitDelivery"}
                    checked={data?.bitDelivery  ===1 ? true :false}
                    sx={{
                      "&.Mui-checked": {
                        color: "#C12637",
                      },
                    }}
                    onChange={(e) =>
                      handleChange("Catering", "bitDelivery", e.target.checked ? 1 : 0)
                    }
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </div>
      <CardActions
        sx={{ backgroundColor: "#FFF8F8", borderTop: "1px solid #C12637",height:'50px' }}
      >
        <Grid container >
          <Grid item xs={6}>
            <Button
              className="text-[#24211F] font-semibold"
              onClick={() => handleRestore("Catering")}
            >
              Restore
            </Button>
          </Grid>
          <Grid item xs={6} container justifyContent={{ xs: "right" }}>
            <LoadingButton
              variant="outlined"
              disabled={loadingButton === "Catering" ? true : false}
              loading={loadingButton === "Catering" ? true : false}
              onClick={() => handleSave("Catering")}
              className="text-[#C12637] font-semibold bg-white border-[#C12637]"
            >
              Save
            </LoadingButton>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

export default CateringTypes;
